/* eslint-disable */

import React from "react"
// import { withPrefix } from "gatsby"
// import type { IFluidObject } from "gatsby-background-image"
// import GatsbyBackgroundImage from "gatsby-background-image"
// import type { Maybe, ImageSharpFluid } from "../../graphql-types"

interface BackgroundImageProps {
  // Can pass either the gatsby image data obtained from childImageSharp?.fluid
  image?: string | any | undefined
  className?: string
  children?: React.ReactNode
  gradientClass?: string
}

const BackgroundImageDiv: React.FC<BackgroundImageProps> = ({
  image,
  children,
  className,
  gradientClass,
}) => (
  <div
    className={className}
    style={{
      backgroundImage: `${
        gradientClass ? `${gradientClass},` : ``
      } url(${image as string})`,
    }}
  >
    {children}
  </div>
)

// const BackgroundImageGatsbyImage: React.FC<BackgroundImageProps> = ({
//   image,
//   children,
//   className,
// }) => (
//   <GatsbyBackgroundImage className={className} fluid={image as IFluidObject}>
//     {children}
//   </GatsbyBackgroundImage>
// )

type BackgroundImageRenderComponentType = typeof BackgroundImageDiv
// | typeof BackgroundImageGatsbyImage

const BackgroundImage: React.FC<BackgroundImageProps> = (props) => {
  const BackgroundImageRenderComponent: BackgroundImageRenderComponentType =
    BackgroundImageDiv
  // switch (typeof props.image) {
  //   case `object`:
  //     BackgroundImageRenderComponent = BackgroundImageGatsbyImage
  //     break

  //   case `string`:
  //     break

  //   default:
  //     return null
  // }
  return <BackgroundImageRenderComponent {...props} />
}

export default BackgroundImage
